import { Routes } from "@angular/router";
import { AuthGuard } from "./authentication/auth.guard";
import { AppBlankComponent } from "./layouts/blank/blank.component";
import { FullComponent } from "./layouts/full/full.component";


export const AppRoutes: Routes = [
    {
        path: "",
        canActivate: [AuthGuard],
        component: FullComponent,
        children: [
            {
                path: "",
                redirectTo: "/authentication/login",
                pathMatch: "full",
            },
            {
                path: "dashboards",
                loadChildren: () => import('./dashboards/dashboards.module').then(x => x.DashboardsModule),
                data: { rState: 0 }
            },

            {
                path: "news",
                loadChildren: () => import('./news/news.module').then(x => x.NewsModule),
                data: { rState: 0 }
            },

            {
                path: "rental",
                loadChildren: () => import('./rental/rental.module').then(x => x.RentalModule),
                data: { rState: 0 }
            },

            {
                path: "account",
                loadChildren: () => import('./account/account.module').then(x => x.AccountModule),
                data: { rState: 0 }
            },

            {
                path: "payment",
                loadChildren: () => import('./payment/payment.module').then(x => x.PaymentModule),
                data: { rState: 0 }
            },

            {
                path: "service-request",
                loadChildren: () => import('./service-request/service-request.module').then(x => x.ServiceRequestModule),
                data: { rState: 0 }
            },

            {
                path: "meter-utility",
                loadChildren: () => import('./meter-utility/meter-utility.module').then(x => x.MeterUtilityModule),
                data: { rState: 0 }
            },

            {
                path: "daily-sales",
                loadChildren: () => import('./daily-sales/daily-sales.module').then(x => x.DailySalesModule),
                data: { rState: 0 }
                // canLoad: [AuthGuard]
            },

            {
                path: "user-management",
                loadChildren: () => import('./user-management/user-management.module').then(x => x.UserManagementModule),
                data: { rState: 0 }
            },

            // {
            //     path: "template",
            //     loadChildren: () => import('./listing-template/listing-template.module').then(x => x.ListingTemplateModule),
            //     data: { rState: 0 }
            // },

            {
                path: "others",
                loadChildren: () => import('./others/others.module').then(x => x.OthersModule),
                data: { rState: 0 }
            },
            {
                path: "components",
                loadChildren: () => import('./shared/components/components.module').then(x => x.ComponentsModule),
                data: { rState: 0 }
            },
            {
                path: 'template',
                loadChildren: () => import('./template/template.module').then(x => x.TemplateModule),
                data: { rState: 0 }
            },
            {
                path: "bill-payments",
                loadChildren: () => import('./bill-payments/bill-payments.module').then(x => x.BillPaymentsModule),
                data: { rState: 0 }
            },
            {
                path: "billings",
                loadChildren: () => import('./billings/billings.module').then(x => x.BillingsModule),
                data: { rState: 0 }
            },
        ],
    },
    {
        path: "",
        component: AppBlankComponent,
        children: [
            {
                path: "tenant-signup",
                loadChildren: () => import('./tenant-signup/tenant-signup.module').then(x => x.TenantSignupModule),
                data: { rState: 0 }
            },
            {
                path: "authentication",
                loadChildren: () => import('./authentication/authentication.module').then(x => x.AuthenticationModule),
                data: { rState: 0 }
            }
        ],
    },
    {
        path: 'tenantapp',
        redirectTo: 'authentication/login',
        data: { rState: 0 }
    },
    {
        path: "**",
        redirectTo: "authentication/404",
        data: { rState: 0 }
    }
];
